/**
 * External dependencies
 */
import React, { memo } from 'react';
import Box from '@mui/material/Box';

/**
 * Internal dependencies
 */
import Loader from '@naruto/naruto-components/src/base/v1/Loader';

function CheckView(): React.ReactElement {
  /* Main */
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'fixed',
        top: '0px',
        left: '0px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Loader />
    </Box>
  );
}

export default memo(CheckView);
